import React, { useLayoutEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  isFullCanvasVisibility,
  setFullCanvasVisibility,
} from "./common/canvasUrlParams";

const VisibilityPersistence: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hadVisibility = useRef(false);

  useLayoutEffect(() => {
    const isFull = isFullCanvasVisibility(location.search);

    if (isFull) {
      hadVisibility.current = true;
      return;
    }

    if (hadVisibility.current) {
      navigate(
        {
          pathname: location.pathname,
          search: `?${setFullCanvasVisibility(location.search)}`,
        },
        { replace: true },
      );
    }
  }, [location.pathname, location.search, navigate]);

  return null;
};

export default VisibilityPersistence;
